import { captureException } from '@sentry/browser'

export default class SilentNetworkError {
  constructor({
    ex, // @type exception
  } = {}) {
    this.ex = ex
  }

  dispatch() {
    captureException(this.ex)
  }
}
